import { isPlatformServer } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, PLATFORM_ID } from '@angular/core';
import { FormControl } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { filter, Subject, take, takeUntil } from 'rxjs';
import { NAV_ITEMS } from '../../../../core/constants/header.constant';
import { UsedCategoryService } from '../../../../features/admin/product/services/used-category.service';

@Component({
    selector: 'app-header',
    standalone: false,
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit, OnDestroy {
    @Input() isScrolled = false;
    @Output() searchRecommender = new EventEmitter<void>();

    protected menuToggle = false;
    protected openMenu: string | null = null;
    protected searchControl = new FormControl('');
    protected showSearch = false;

    protected NAV_ITEMS = NAV_ITEMS;

    private destroy$ = new Subject<void>();

    constructor(
        @Inject(PLATFORM_ID) private platformID: object,
        private router: Router,
        private usedCategoriesService: UsedCategoryService,
    ) {}

    ngOnInit(): void {
        if (isPlatformServer(this.platformID)) {
            return;
        }

        this.setUsedCategories();
        this.subscribeToRouter();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    protected closeSearch(): void {
        this.showSearch = false;
    }

    protected openSearchRecommender(): void {
        this.searchRecommender.emit();
    }

    protected onSearch(): void {
        const value = this.searchControl.value?.trim();

        if (!value) {
            return;
        }

        this.router.navigate(['/products'], {
            queryParams: { search: value },
        });
    }

    protected toggleSearch(): void {
        this.showSearch = !this.showSearch;
    }

    protected toggleMenu(): void {
        this.menuToggle = !this.menuToggle;
    }

    protected toggleSearchMenu(): void {
        this.toggleMenu();
        this.toggleSearch();
    }

    protected toggleChild(key: string): void {
        if (this.openMenu === key) {
            this.openMenu = null;
            return;
        }

        this.openMenu = key;
    }

    private subscribeToRouter(): void {
        this.router.events
            .pipe(
                filter((event) => {
                    if (!(event instanceof NavigationEnd)) {
                        return false;
                    }
                    return window.innerWidth <= 768;
                }),
                takeUntil(this.destroy$),
            )
            .subscribe(() => {
                this.menuToggle = false;
                this.openMenu = null;
                this.showSearch = false;
            });
    }

    private setUsedCategories(): void {
        this.usedCategoriesService
            .getUsedCategories()
            .pipe(take(1))
            .subscribe((response) => {
                const navProduct = NAV_ITEMS.findIndex((nav) => nav.label === 'Products');
                NAV_ITEMS[navProduct].children = NAV_ITEMS[navProduct].children?.filter((navChild) =>
                    response.result.includes(navChild.filter),
                );
            });
    }
}
